import { createRoot } from "react-dom/client";
import WinnersCategoryPage from "../app/(general-header)/winners/category/[category]/page";
import { StoreProvider } from "../app/storeProvider";
import React from "react";

const root = createRoot(document.getElementById("winners-category-container") as HTMLElement);

root.render(
  <React.StrictMode>
    <StoreProvider>
      <WinnersCategoryPage />
    </StoreProvider>
  </React.StrictMode>
);
